import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import { OnboardingFormValues } from "./shared/types"

interface NewUserFormProps {
  defaultValues?: OnboardingFormValues["newUserInput"]
  isSubmitting?: boolean
  submitBtnLabel?: string
  disableEmailInput?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewUserForm',
  props: {
    defaultValues: null,
    isSubmitting: { type: Boolean },
    submitBtnLabel: null,
    disableEmailInput: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { emit }) {

const props = __props as {
  defaultValues?: OnboardingFormValues["newUserInput"]
  isSubmitting?: boolean
  submitBtnLabel?: string
  disableEmailInput?: boolean
}




const form = ref({
  firstName: props.defaultValues?.firstName || "",
  lastName: props.defaultValues?.lastName || "",
  email: props.defaultValues?.email || "",
  clientAdminPosition: props.defaultValues?.clientAdminPosition || "",
})

const onSubmit = () => {
  emit("submit", form.value)
}

return { __sfc: true,props, emit, form, onSubmit }
}

})